import Swiper from 'swiper'
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css/bundle'

window.Swiper = Swiper
window.Swiper_Modules = [Navigation, Pagination, Autoplay];